import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import DeleteModal from 'pages/parts/DeleteModal'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { findKeyFromArrayByValue, returnSign } from "helpers/helpers"
import { docsPageUrl } from "helpers/apps"
import HintIcon from 'pages/parts/HintIcon'

function Index() {
	const { t, i18n } = useTranslation()

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('delete') },
	]

	const [data, setData] = useState([])
	const [accountsChef, setAccountsChef] = useState([])
	const [accounts, setAccounts] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({
		'transaction_type': 'minus',
		'is_account_required': true,
		'account_chef_id': null,
		'account_core_id': 18,
		'show_in_cashbox': true,
	})
	const [filterData, setFilterData] = useState({ 'status': 1 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/payment-purpose-types', selectedItem, { loader: true })
		} else {
			response = await POST('/payment-purpose-types', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
			setSelectedItem({})
		}
	}

	async function deleteItem() {
		const response = await DELETE(`/payment-purpose-types/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/payment-purpose-types"
		var urlParams = ""

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
		}

		setDropdownIsOpen(false)
	}

	async function toggleModal(
		bool = false,
		item = {
			'transaction_type': 'minus',
			'is_account_required': true,
			'account_chef_id': null,
			'account_core_id': 18,
			'show_in_cashbox': true
		}
	) {
		const nextItem = { ...item }
		if (nextItem.is_account_required === undefined || nextItem.is_account_required === null) {
			nextItem.is_account_required = !['neutral', 'neutral_plus'].includes(nextItem.transaction_type)
		}
		if (nextItem.transaction_type === 'neutral') nextItem.transaction_type = 'minus'
		if (nextItem.transaction_type === 'neutral_plus') nextItem.transaction_type = 'plus'

		let accountList = accounts
		if (bool && !accountList.length) {
			accountList = await getAccounts()
			await getAccountsChef()
		}
		if (bool && nextItem.is_account_required && !nextItem.account_chef_id) {
			nextItem.account_chef_id = getDefaultCashAccountId(accountList)
		}

		setShowModal(bool)
		setSelectedItem(nextItem)
	}

	function setTransactionType(type) {
		setSelectedItem({ ...selectedItem, 'transaction_type': type })
	}

	function setIsAccountRequired(value) {
		const next = { ...selectedItem, 'is_account_required': value }
		if (!value) {
			next.account_chef_id = null
		} else if (!next.account_chef_id) {
			next.account_chef_id = getDefaultCashAccountId()
		}
		setSelectedItem(next)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getAccountsChef() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) {
			setAccountsChef(response.data)
			return response.data
		}
		return []
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) {
			setAccounts(response.data)
			return response.data
		}
		return []
	}

	function getDefaultCashAccountId(list = accounts) {
		const cashAccount = list.find((item) => String(item.code) === '1.02')
			|| list.find((item) => String(item.name || '').toLowerCase() === 'касса')
		return cashAccount?.id ?? null
	}

	// Плоский список -> дерево для Select.
	// Не выбираются только самые верхние корни (level 0); остальные узлы — можно.
	function buildAccountOptions(list = []) {
		const childrenOf = {}
		const known = new Set(list.map((item) => Number(item.id)))

		list.forEach((item) => {
			const parentId = known.has(Number(item.parent_id)) ? Number(item.parent_id) : null
			if (!childrenOf[parentId]) childrenOf[parentId] = []
			childrenOf[parentId].push(item)
		})

		const options = []
		const walk = (parentId, level) => {
			(childrenOf[parentId] || []).forEach((item) => {
				const counterpartyName = counterpartyLabel(item)
				options.push({
					...item,
					level,
					isDisabled: level === 0,
					treeLabel: `${'\u00A0\u00A0\u00A0\u00A0'.repeat(level)}${item.name}${item.code ? ` (${item.code})` : ''}${counterpartyName ? ` — ${counterpartyName}` : ''}`,
				})
				walk(Number(item.id), level + 1)
			})
		}
		walk(null, 0)
		return options
	}

	function counterpartyLabel(item) {
		if (!item?.counterparty) return ''
		if (item.counterparty === 'supplier') return t('supplier')
		if (item.counterparty === 'employee' || item.counterparty === 'employee_salary') return t('employee')
		if (item.counterparty === 'agent') return t('agent')
		if (item.counterparty === 'organization') return t('organization')
		if (item.counterparty === 'client') return t('client')
		return t('counterparty')
	}

	function returnEntityType(item) {
		var name = t('no')
		if (item?.counterparty === 'supplier') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'agent') {
			name = t('agent')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'client') {
			name = t('client')
		}

		return name
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const accountOptions = buildAccountOptions(accounts)
	const accountChefOptions = buildAccountOptions(accountsChef.length ? accountsChef : accounts)
	const accountSelectProps = {
		menuPosition: 'fixed',
		menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
		menuPlacement: 'auto',
		styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
		placeholder: '',
		noOptionsMessage: () => t('list_empty'),
		getOptionLabel: (option) => option.treeLabel || option.name,
		getOptionValue: (option) => option.id,
		isOptionDisabled: (option) => !!option.isDisabled,
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('expenses')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					<a className="btn-rounded btn btn-outline-primary text-nowrap" target="_blank" rel="noreferrer"
						href={docsPageUrl('finance_profit_loss', i18n.language) + '#' + t('pl_docs_anchor')}>
						<i className="uil uil-book-open me-1"></i>{t('documentation')}
					</a>
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					<div className="filter-block">
						<div className="filter">
							<strong>{t('filter')}</strong>
							<br />
							{filterData.search &&
								<span className="me-2">
									<b>{t('search')}: </b>
									<span>{filterData.search}</span>
								</span>
							}
							{filterData.status &&
								<span className="me-2">
									<b>{t('status')}: </b>
									{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
								</span>
							}
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-hover table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }}>{t('operation_account')}</th>
									<th style={{ 'width': '20%' }}>{t('report_account')}</th>
									<th style={{ 'width': '10%' }}>{t('limit')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('is_account_required')}</th>
									<th style={{ 'width': '10%' }}>{t('counterparty')}</th>
									<th style={{ 'width': '10%' }} className="text-center text-nowrap td-ellipsis"
										title={t('show_in_cashbox')}>
										{t('show_in_cashbox')}
									</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={item.name}>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="td-ellipsis" title={item.account_chef_name}>{item.account_chef_name}</td>
										<td className="td-ellipsis" title={item.account_core_name}>{item.account_core_name}</td>
										<td></td>
										<td>
											{(item.transaction_type === 'minus' || item.transaction_type === 'neutral') &&
												<span>{t('expense')}</span>
											}
											{(item.transaction_type === 'plus' || item.transaction_type === 'neutral_plus') &&
												<span>{t('income')}</span>
											}
										</td>
										<td>
											{(item.is_account_required === false || item.transaction_type === 'neutral' || item.transaction_type === 'neutral_plus')
												? t('no')
												: t('yes')
											}
										</td>
										<td>{returnEntityType(item)}</td>
										{/* Колонка узкая и однотипная — цветной маркер читается быстрее слов «да/нет» */}
										<td className="text-center">
											<span className={'bg-border ' + (item.show_in_cashbox ? 'bg-primary' : 'bg-danger')}
												title={item.show_in_cashbox ? t('yes') : t('no')}></span>
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														{item.status !== -1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index })
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off" noValidate>
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('type')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setTransactionType('minus')}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'minus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setTransactionType('minus')}>
											{t('expense')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setTransactionType('plus')}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'plus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setTransactionType('plus')}>
											{t('income')}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('is_account_required')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setIsAccountRequired(true)}
											style={{ 'backgroundColor': selectedItem.is_account_required ? 'black' : '' }}>
										</div>
										<span onClick={() => setIsAccountRequired(true)}>
											{t('yes')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setIsAccountRequired(false)}
											style={{ 'backgroundColor': !selectedItem.is_account_required ? 'black' : '' }}>
										</div>
										<span onClick={() => setIsAccountRequired(false)}>
											{t('no')}
										</span>
									</div>
								</div>
							</div>
						</div>
						{selectedItem.is_account_required &&
							<>
								<div className="form-group">
									<label>{t('operation_account')}<span className="required-mark">*</span></label>
									<Select
										isClearable
										{...accountSelectProps}
										options={accountChefOptions}
										value={accountChefOptions.find(option => option.id === selectedItem.account_chef_id) || null}
										onChange={(option) => setSelectedItem({ ...selectedItem, 'account_chef_id': option ? option.id : null })}
									/>
								</div>
								<div className="form-group">
									<label>{t('report_account')}<span className="required-mark">*</span><HintIcon text={t('report_account_hint')} /></label>
									<Select
										{...accountSelectProps}
										options={accountOptions}
										value={accountOptions.find(option => option.id === selectedItem.account_core_id) || null}
										onChange={(option) => setSelectedItem({ ...selectedItem, 'account_core_id': option ? option.id : null })}
									/>
								</div>
							</>
						}
						{!selectedItem.is_account_required &&
							<div className="form-group">
								<label>{t('report_account')}<HintIcon text={t('is_account_required_hint')} /></label>
								<Select
									{...accountSelectProps}
									options={accountOptions}
									isClearable
									value={accountOptions.find(option => option.id === selectedItem.account_core_id) || null}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'account_core_id': option ? option.id : null })}
								/>
							</div>
						}
						<div className="form-group">
							<label>{t('show_in_cashbox')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'show_in_cashbox': true })}
											style={{ 'backgroundColor': selectedItem.show_in_cashbox ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'show_in_cashbox': true })}>
											{t('yes')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'show_in_cashbox': false })}
											style={{ 'backgroundColor': !selectedItem.show_in_cashbox ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'show_in_cashbox': false })}>
											{t('no')}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
			{/* MODAL */}
		</>
	)
}

export default Index